// Brand names for an online event's platform (EventInstance.online_platform; the choices are
// ONLINE_PLATFORM_CHOICES in api/events/models.py). "other" and blank have no name.
const PLATFORM_NAMES = {
  zoom: 'Zoom',
  teams: 'Microsoft Teams',
  google_meet: 'Google Meet',
};

/** `text` (the translated "Online"/"Online Event") with the platform after it, e.g. "Online (Zoom)". */
export function withPlatform(text, platform) {
  const name = PLATFORM_NAMES[platform];
  return name ? `${text} (${name})` : text;
}
